import React from 'react';
import PropTypes from 'prop-types';
const inputComponent = React.forwardRef(function inputComponent(props, ref) {
   const {...other} = props;
   return <div ref={ref} {...other} />;
});

inputComponent.propTypes = {
   // ref: PropTypes.oneOfType([
   //    PropTypes.func,
   //    PropTypes.shape({
   //       current: PropTypes.any.isRequired
   //    })
   // ])
};

export default inputComponent;
